import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { TooltipQuestion } from 'builder/components/Tooltip/variations'

export const Container = styled.div<{
  isRDVersion2: boolean
}>`
  width: ${props => (props.isRDVersion2 ? 'auto' : '100%;')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${props => (props.isRDVersion2 ? 'none' : Spacing.S)};
  border-radius: ${props => (props.isRDVersion2 ? 'none' : Spacing['2XS'])};
  background: ${props => (props.isRDVersion2 ? 'none' : Colors.Blue10)};
  gap: ${props => (props.isRDVersion2 ? Spacing.S : '0')};
`

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.XS};
`

export const Title = styled.p`
  font-size: 16px;
  line-height: 20px;
  color: ${Colors.Neutral90};
`

export const CountContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`

export const CountText = styled.p`
  width: 100%;
  font-size: 33px;
  ${FontWeights.Medium};
  line-height: 34px;
  text-align: right;
  color: ${Colors.Blue50};
`

export const TooltipWrapper = styled.div`
  display: flex;

  ${Media.Phone`
    padding-left: 8px;
  `};
`

export const TooltipQuestionWrapper = styled(TooltipQuestion)<{ align: any }>`
  & div > svg {
    color: ${Colors.Neutral90};
  }
`
